import { Spacer } from '@chakra-ui/react';
import { ServiceProductDetail } from 'model/modules/services/serviceProductItem';
import { FC } from 'react';
import ServiceProductIntroCard from './ServiceProductIntroCard';
import ServiceProductContentCard from './ServiceProductContentCard';

interface Props {
  data: ServiceProductDetail;
}

const ServiceProductDetailLoaded: FC<Props> = ({ data }) => {
  return (
    <>
      <ServiceProductIntroCard
        title={data.title}
        subtitle={data.subtitle}
        subtitle2={data.subtitle2}
        detailImageUrl={data.detailImageUrl}
        primaryColor={data.primaryColor}
      />
      <Spacer h="20px" />
      {data.content && <ServiceProductContentCard content={data.content} />}
    </>
  );
};

export default ServiceProductDetailLoaded;
